const IDLE_CALLBACK_TIMEOUT = 1000;

class Sensor {
	id = null;

	device = null;

	config = null;

	cachedValue = null;

	state = {};

	constructor({ id, device, config }) {
		this.id = id;
		this.device = device;
		this.config = config;
		this.setup();
	}

	get store() {
		const { store } = this.device.config;
		if (!store || !store.commit || !store.mutations) return null;

		return store;
	}

	setup() {
		if (this.config.setup({ self: this }) !== false) {
			this.setValue(this.getValue());
		}
	}

	update = () => {
		if (!this.config.update) return;
		this.config.update({ self: this });
	};

	getValue() {
		return this.config.getValue({ self: this });
	}

	emitValue(value) {
		if (this.store) {
			const mutation = this.store.mutations[this.id];
			if (mutation) this.store.commit(mutation, value);
		}
	}

	setValue = (value) => {
		const handler = () => {
			this.cachedValue = value;
			this.emitValue(value);
		};

		if (this.device.supports.requestIdleCallback) {
			requestIdleCallback(handler, { timeout: IDLE_CALLBACK_TIMEOUT });
		} else {
			setTimeout(handler, 0);
		}
	};
}

export default Sensor;
